// extracted by mini-css-extract-plugin
export default {"container":"EmptyStore_container__gX7NA"};